export default __webpack_public_path__ + "static/media/BasicVideo4.b4358724.png";